
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/snoerapport",
      function () {
        return require("private-next-pages/snoerapport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/snoerapport"])
      });
    }
  